module.exports = __webpack_public_path__ + "static/media/logo_original.fd60cb92.png";